import licenseModule from './license.module';
import template from './license.component.html';

export default licenseModule.component('license', {
    template: template
});



// WEBPACK FOOTER //
// ./modules/license/license.component.js